import React, {useEffect} from 'react';
import {ScheduleTable} from "../../groups/group-container/schedule-table/ScheduleTable";
import {MainTop} from "../../groups/group-container/main-top/Main-top";
import {ReactComponent as ArraLeftIcon} from '../../../../assets/main/groups/main-table/array-left.svg';
import {ResponseOptions} from "./response-options/ResponseOptions";
import {useAppDispatch, useAppSelector} from "common/hook";
import {Navigate, useParams} from "react-router-dom";
import {ROLE_TEACHER} from "entities/constants/constants";
import AuthWrapper from "../../../auth-wrapper/AuthWrapper";
import {testViewAnswerId} from "features/model/service/test/test-view-answer-id/testViewAnswerId";
import {Skeleton} from "antd";

export const TestInnerAnswer = () => {
    const dispatch = useAppDispatch()
    const roleType = useAppSelector((state) => state.role.roleType);
    const modelData = useAppSelector(state => state.testViewAnswerId.serverData?.data?.model);
    const {testId, userId} = useParams()


    useEffect(() => {
        if (testId && userId) {
            dispatch(testViewAnswerId({testId, userId}));
        }
    }, [testId, userId, dispatch]);

    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop
                    title={modelData?.title || <Skeleton.Input active={true}/>}
                    tabs={false} setting={false}
                    link={'/test'}
                    icons={<ArraLeftIcon/>}/>
                         {roleType === ROLE_TEACHER && (
                    <>
                        <ScheduleTable/>
                        <hr/>
                    </>
                )}
                <ResponseOptions/>
            </div>
        </AuthWrapper>
    );
};

